namespace Core {
    export interface IFidParser {
        parse(): number | null;
    }

    function fidParser ($location) : IFidParser {
        return {
            parse : () => {
                let fid = $location.search().fid;
                if (!fid && (TRPCONFIG.Domain.UseIdBasedUrls)) {
                    let path = ($location.path() || '').match(/(?:\d+-\d+-\d+-)(\d+)/);
                    if (path && path[1]) {
                        fid = path[1];
                    }
                }

                fid = fid === '0' || fid === 0 ? null : fid;
                return fid == null ? null : _.toNumber(fid);
            }
        };
    }

    angular
        .module('core')
        .service('fidParser', fidParser);

}
